import React from 'react';
import { useThemes } from '@core/hooks';

interface FormFooterProps {
  setPopupVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const FormFooter = ({ setPopupVisible }: FormFooterProps) => {
  const { isDark } = useThemes();

  return (
    <footer
      className={`login-form-footer ${
        !isDark ? 'login-form-footer--light' : ''
      }`}
    >
      <p
        className={`login-form-footer__title ${
          !isDark ? 'login-form-footer__title--light' : ''
        }`}
      >
        <a href="https://ex7.pl/">
          &#169; {new Date().getFullYear()} EX7 Software Solutions
        </a>
        <span
          tabIndex={0}
          aria-label="api-button"
          className="role-button"
          role="button"
          onClick={() => setPopupVisible(true)}
        />
      </p>
    </footer>
  );
};

export default FormFooter;
